var map = {
	"./1/symbol_0.png": 88917,
	"./1/symbol_1.png": 77292,
	"./1/symbol_10.png": 73622,
	"./1/symbol_11.png": 51711,
	"./1/symbol_12.png": 38148,
	"./1/symbol_2.png": 44327,
	"./1/symbol_3.png": 68542,
	"./1/symbol_4.png": 13105,
	"./1/symbol_5.png": 64712,
	"./1/symbol_6.png": 26691,
	"./1/symbol_7.png": 36858,
	"./1/symbol_8.png": 89741,
	"./1/symbol_9.png": 26500,
	"./2/symbol_0.png": 75096,
	"./2/symbol_1.png": 43361,
	"./2/symbol_10.png": 62645,
	"./2/symbol_11.png": 26732,
	"./2/symbol_12.png": 29383,
	"./2/symbol_2.png": 94378,
	"./2/symbol_3.png": 49587,
	"./2/symbol_4.png": 49628,
	"./2/symbol_5.png": 79045,
	"./2/symbol_6.png": 7246,
	"./2/symbol_7.png": 50263,
	"./2/symbol_8.png": 99728,
	"./2/symbol_9.png": 96633,
	"./3/symbol_0.png": 37547,
	"./3/symbol_1.png": 73890,
	"./3/symbol_10.png": 34168,
	"./3/symbol_12.png": 14218,
	"./3/symbol_2.png": 87897,
	"./3/symbol_3.png": 72144,
	"./3/symbol_4.png": 68015,
	"./3/symbol_5.png": 99270,
	"./3/symbol_6.png": 66685,
	"./3/symbol_7.png": 45556,
	"./3/symbol_8.png": 40851,
	"./3/symbol_9.png": 90090,
	"./4/symbol_0.png": 41726,
	"./4/symbol_1.png": 94215,
	"./4/symbol_10.png": 18375,
	"./4/symbol_12.png": 67413,
	"./4/symbol_2.png": 91564,
	"./4/symbol_3.png": 43829,
	"./4/symbol_4.png": 3706,
	"./4/symbol_5.png": 67811,
	"./4/symbol_6.png": 30952,
	"./4/symbol_7.png": 24817,
	"./4/symbol_8.png": 47510,
	"./4/symbol_9.png": 60799
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12787;